import React from 'react';
import { createStyles, WithStyles, withStyles } from '@material-ui/core';

import { UnloggedLayout } from '../layouts/UnloggedLayout';
import { Box } from '../Box';
import { BoxHeader } from '../BoxHeader';
import { useTranslator } from '../../i18n/useTranslator';
import { HelpMessage } from '../HelpMessage';
import { ResetPasswordForm } from '../forms/ResetPasswordForm';

const styles = () => createStyles({});

type Props = WithStyles<typeof styles>;

const ResetPasswordScreenComponent: React.FunctionComponent<Props> = () => {
  const { t } = useTranslator();

  return (
    <UnloggedLayout>
      <Box>
        <BoxHeader title={t('changePassword')} />
        <ResetPasswordForm />
        <HelpMessage />
      </Box>
    </UnloggedLayout>
  );
};

export const ResetPasswordScreen = withStyles(styles)(ResetPasswordScreenComponent);